export var StoreItemPromotionRelationType;
(function (StoreItemPromotionRelationType) {
    StoreItemPromotionRelationType["DISCOUNTED"] = "DISCOUNTED";
    StoreItemPromotionRelationType["ADDED"] = "ADDED";
    StoreItemPromotionRelationType["DISCOUNT_PRODUCER"] = "DISCOUNT_PRODUCER";
})(StoreItemPromotionRelationType || (StoreItemPromotionRelationType = {}));
//# sourceMappingURL=StoreItemPromotionRelationType.js.map